export class RoomRewards {
    constructor(bingo, figure) {
        this.bingo = bingo;
        this.figure = figure;
    }
    toJSON() {
        const { bingo, figure } = this;
        return { bingo, figure };
    }
}
